import React, { Component } from 'react';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import _ from 'lodash';
import classnames from 'classnames';

import { Select, Icon, Row, Col } from 'antd';
const Option = Select.Option;
import { updateQuery } from 'modules/router/actions';

const container = connect(
  createSelector(
    (state) => ({
      pathname: _.get(state, 'router.location.pathname'),
      query: _.get(state, 'router.location.query'),
      sourceGroup: _.get(state, 'sourceGroup'),
      subjects: _.get(state, 'subject.entities'),
    }),
    (state) => {
      const { query, sourceGroup, subjects, pathname } = state;
      const routers = pathname.split('/');
      const subjectId = _.get(query, 'subjectId');
      const subject = subjects[subjectId];
      const mediaTypeId = _.get(query, 'mediaType', null);
      const sourceGroups = _.get(sourceGroup, `entities.${mediaTypeId}`);
      const sections = _.get(sourceGroup, mediaTypeId);
      const defaultSection = _.get(sourceGroup, `byId.[${query.sourceGroupId}].name`, null);
      let mediaTypeSection = []
      let mapSourceGroups = {}
      _.map(_.get(subject, `queries.${mediaTypeId}.source`), (s) => {
        mediaTypeSection = [...mediaTypeSection, _.get(sourceGroup, `byId.[${s.sourceGroupId}].name`, null)];
        if (_.isEmpty(s.from)) {
          mapSourceGroups = {
            ...mapSourceGroups,
            [_.get(sourceGroup, `byId.[${s.sourceGroupId}].name`)]: _.get(sourceGroup, `byId.[${s.sourceGroupId}].sources`)
          }
        } else {
          if (!_.isEmpty(mapSourceGroups[_.get(sourceGroup, `byId.[${s.sourceGroupId}].name`)])) {
            mapSourceGroups = {
              ...mapSourceGroups,
              [_.get(sourceGroup, `byId.[${s.sourceGroupId}].name`)]: [
                ...mapSourceGroups[_.get(sourceGroup, `byId.[${s.sourceGroupId}].name`)],
                s.from
              ]
            }
          } else {
            mapSourceGroups = {
              ...mapSourceGroups,
              [_.get(sourceGroup, `byId.[${s.sourceGroupId}].name`)]: [
                s.from
              ]
            }
          }
        }
      })
      mediaTypeSection = _.uniq(mediaTypeSection)
      return ({
        defaultSection,
        query,
        mediaTypeId,
        sections,
        sourceGroups,
        subjects,
        mediaTypeSection,
        mapSourceGroups,
      })
    }
  )
)

class SourcePanel extends Component {

  state = {
    selectedSection: this.props.defaultSection,
    mediaTypeSection: [],
  }

  handleSourceChange = (value) => {
    const { dispatch } = this.props;

    dispatch(updateQuery({
      from: value,
      in: []
    }));
  }

  handelDeleteSource = (_from) => {
    const { dispatch, query } = this.props;
    const result = _.without([].concat(query.from), _from);
    dispatch(updateQuery({
      from: result,
      in: []
    }));
  }

  handelDeleteBy = (by) => {
    const { dispatch, query } = this.props;
    const result = _.without([].concat(query.by), by);
    dispatch(updateQuery({
      by: result
    }));
  }

  handleSectionChange = (section) => {
    const { dispatch, sourceGroups } = this.props;

    const _sourceGroupId = section ? _.get(sourceGroups, `[${section}].id`) : null
    dispatch(updateQuery({
      sourceGroupId: _sourceGroupId
    }));
    this.setState({
      selectedSection: section
    })
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, subjects, query } = nextProps;
    if (nextProps.defaultSection !== this.props.defaultSection) {
      this.setState({
        selectedSection: _.get(nextProps, 'defaultSection'),
      })
    }
    const mediaTypes = _.keys(_.get(subjects[query.subjectId], 'queries'))
    if (query.subjectId !== this.props.query.subjectId) {
      if (mediaTypes.length == 1) {
        dispatch(updateQuery({ mediaType: mediaTypes[0] }))
      }
    }
  }

  render() {
    const { query, mediaTypeId, sections, sourceGroups, dispatch, mediaTypeSection, mapSourceGroups, disabledSource } = this.props;
    const sources = _.get(sourceGroups, `${this.state.selectedSection}.sources`);
    const otherSources = _.get(mapSourceGroups, `${this.state.selectedSection}`);
    const mapSources = _.isEmpty(mapSourceGroups) ? sources : otherSources;
    const defaultSelect = _.get(query, 'from');
    let mapSections = _.map(mediaTypeSection, (s) => {
      if (_.includes(sections, s)) {

        return s
      }
    })

    if (_.isEmpty(mapSections)) {
      mapSections = sections

    }
    return (
      <div>
        {!disabledSource &&
          <div className="query-panel-header">
            <Row className="source-row">
              <Col span='2'>
                <span className="query-panel-title">{t('commonFrom')}：</span>
              </Col>
              <Col span='22'>
                <div>
                  <div
                    className={classnames("query-label", {
                      active: this.state.selectedSection === null,
                    })}
                    onClick={() => this.handleSectionChange([])}
                  >
                    {t('commonAll')}
                  </div>
                  {
                    _.map(_.uniq(mapSections), (section, i) =>
                      <div
                        className={classnames("query-label", {
                          active: section === this.state.selectedSection,
                        })}
                        key={i}
                        onClick={() => this.handleSectionChange(section)}
                      >

                        {t(section)}
                      </div>
                    )
                  }
                  <div className="margin-top-sm margin-bottom-sm" style={{display: 'inline-block', width: '15%', color: "#aaa !important"}}>
                    {this.state.selectedSection !== null &&
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder={t('commonSource')}
                        optionFilterProp="children"
                        notFoundContent={t('commonNoData')}
                        onChange={this.handleSourceChange}
                        value={defaultSelect}
                      >
                        {
                          _.map(_.uniq(mapSources), (source, i) =>
                            <Option value={source} key={source} title={source}>{source}</Option>
                          )
                        }
                      </Select>
                    }
                  </div>
                </div>
              </Col>

            </Row>
          </div>
        }
      </div>

    )
  }
}

export default container(SourcePanel)



/** WEBPACK FOOTER **
 ** ./src/app/modules/controlPanel/components/SourcePanel.js
 **/